var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F1F1F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_698_5811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_698_5811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.375 29.5V23.6635H13.602C13.0182 23.6635 12.5218 23.4582 12.113 23.0475C11.7043 22.6368 11.5 22.1382 11.5 21.5515C11.5 21.1262 11.6157 20.7333 11.8472 20.373C12.0786 20.0128 12.3853 19.7456 12.7673 19.5712L19.25 16.6905V15.7422C18.6757 15.5769 18.2083 15.2593 17.848 14.7895C17.4878 14.3197 17.3078 13.7873 17.3078 13.1923C17.3078 12.4444 17.5691 11.8087 18.0918 11.2852C18.6143 10.7617 19.2488 10.5 19.9955 10.5C20.742 10.5 21.3765 10.7628 21.899 11.2885C22.4215 11.8142 22.6827 12.4488 22.6827 13.1923H21.1635C21.1635 12.8544 21.052 12.5713 20.829 12.3428C20.606 12.1143 20.3297 12 20 12C19.6622 12 19.379 12.1143 19.1505 12.3428C18.922 12.5713 18.8078 12.8544 18.8078 13.1923C18.8078 13.5301 18.922 13.8132 19.1505 14.0417C19.379 14.2704 19.6622 14.3848 20 14.3848C20.2125 14.3848 20.3906 14.4566 20.5343 14.6003C20.6781 14.7441 20.75 14.9223 20.75 15.1348V16.6905L27.223 19.5712C27.6047 19.7469 27.9129 20.0142 28.1477 20.373C28.3826 20.7318 28.5 21.1236 28.5 21.5483C28.5 22.1341 28.2947 22.6331 27.884 23.0452C27.4735 23.4574 26.975 23.6635 26.3885 23.6635H24.625V29.5H15.375ZM13.602 22.1635H15.375V21.1923H24.625V22.1635H26.3885C26.5628 22.1635 26.7083 22.1026 26.825 21.9808C26.9417 21.8589 27 21.7058 27 21.5213C27 21.3994 26.9696 21.2885 26.9087 21.1885C26.8477 21.0885 26.7563 21.0122 26.6345 20.9595L20 18.0078L13.375 20.9595C13.2532 21.0122 13.1603 21.0885 13.0963 21.1885C13.0321 21.2885 13 21.3994 13 21.5213C13 21.7058 13.0564 21.8589 13.1693 21.9808C13.2821 22.1026 13.4263 22.1635 13.602 22.1635ZM16.875 28H23.125V22.6923H16.875V28Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.be51ee8347e083117c7935b20808b8bd.svg";
export { ForwardRef as ReactComponent };